import React from 'react'
import PropTypes from 'prop-types'
import { Bar, defaults, Chart } from 'react-chartjs-2'
import { Box } from '@material-ui/core'
import moment from 'moment'

import SOVColors from '../../constants/colors'
import ChartDateHighlighter from '../../classes/ChartDateHighlighter'

export class BarWrap extends React.Component {
  static propTypes = {
    sovNetworks: PropTypes.array,
    sovNetwork1: PropTypes.object,
    sovNetwork2: PropTypes.object,
    sovNetwork3: PropTypes.object,
    sovNetwork4: PropTypes.object,
    sovNetwork5: PropTypes.object,
    dateIndex: PropTypes.number,
    selectedDate: PropTypes.string,
    setDateIndex: PropTypes.func,
    dateArray: PropTypes.array
  }

  componentDidMount () {
    let that = this
    Chart.pluginService.register({
      afterDraw: function (chart) {
        if (chart.config.type === 'bar') {
          let ctx = chart.ctx
          ChartDateHighlighter.drawDateHighlihter(chart, ctx, that.props.dateArray)
        }
      }
    })
  }

  render () {
    const { sovNetwork1, sovNetwork2, sovNetwork3, sovNetwork4, sovNetwork5 } = this.props
    const sovNetworks = []
    if (sovNetwork1) { sovNetworks.push(sovNetwork1) }
    if (sovNetwork2) { sovNetworks.push(sovNetwork2) }
    if (sovNetwork3) { sovNetworks.push(sovNetwork3) }
    if (sovNetwork4) { sovNetworks.push(sovNetwork4) }
    if (sovNetwork5) { sovNetworks.push(sovNetwork5) }
    const uniqueNetworks = sovNetworks.reduce((unique, o) => {
      if (!unique.some(obj => obj.label === o.label)) {
        unique.push(o)
      }
      return unique
    }, [])
    defaults.fontFamily = 'Uni Sans Regular'
    let dataSet = []
    let data = {}
    const labels = sovNetwork1 && sovNetwork1.metrics.map(m => m.date)
    if (uniqueNetworks && uniqueNetworks.length > 0 && uniqueNetworks[0] && uniqueNetworks[0].metrics.length > 0) {
      const sovNetwork1Data = {
        label: uniqueNetworks[0].label,
        backgroundColor: SOVColors.getSOVColors(uniqueNetworks[0].label),
        data: uniqueNetworks[0].metrics.map(m => Math.round(m.score * 100) / 100),
        barThickness: 20
      }
      dataSet.push(sovNetwork1Data)
    }
    if (uniqueNetworks && uniqueNetworks.length > 1 && uniqueNetworks[1] && uniqueNetworks[1].metrics.length > 0) {
      const sovNetwork2Data = {
        label: uniqueNetworks[1].label,
        backgroundColor: SOVColors.getSOVColors(uniqueNetworks[1].label),
        data: uniqueNetworks[1].metrics.map(m => Math.round(m.score * 100) / 100),
        barThickness: 20
      }
      dataSet.push(sovNetwork2Data)
    }
    if (uniqueNetworks && uniqueNetworks.length > 2 && uniqueNetworks[2] && uniqueNetworks[2].metrics.length > 0) {
      const sovNetwork3Data = {
        label: uniqueNetworks[2].label,
        backgroundColor: SOVColors.getSOVColors(uniqueNetworks[2].label),
        data: uniqueNetworks[2].metrics.map(m => Math.round(m.score * 100) / 100),
        barThickness: 20
      }
      dataSet.push(sovNetwork3Data)
    }
    if (uniqueNetworks && uniqueNetworks.length > 3 && uniqueNetworks[3] && uniqueNetworks[3].metrics.length > 0) {
      const sovNetwork4Data = {
        label: uniqueNetworks[3].label,
        backgroundColor: SOVColors.getSOVColors(uniqueNetworks[3].label),
        data: uniqueNetworks[3].metrics.map(m => Math.round(m.score * 100) / 100),
        barThickness: 20
      }
      dataSet.push(sovNetwork4Data)
    }
    if (uniqueNetworks && uniqueNetworks.length > 4 && uniqueNetworks[4] && uniqueNetworks[4].metrics.length > 0) {
      const sovNetwork5Data = {
        label: uniqueNetworks[4].label,
        backgroundColor: SOVColors.getSOVColors(uniqueNetworks[4].label),
        data: uniqueNetworks[4].metrics.map(m => Math.round(m.score * 100) / 100),
        barThickness: 20
      }
      dataSet.push(sovNetwork5Data)
    }

    if (dataSet.length > 0) {
      data = {
        labels: labels,
        datasets: dataSet
      }
    }

    const options = {
      animation: false,
      responsive: true,
      maintainAspectRatio: true,
      legend: {
        display: false
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      scales: {
        yAxes: [{
          gridLines: {
            display: true
          },
          stacked: true,
          ticks: {
            display: true,
            fontSize: 12,
            fontColor: '#A7A9AC',
            callback: function (label) {
              return `${label}%`
            }
          }
        }],
        xAxes: [{
          ticks: {
            fontSize: 12,
            fontColor: '#A7A9AC',
            autoSkip: false,
            maxRotation: 0,
            minRotation: 0,
            callback: function (label) {
              return new Date(label).getDay() === 1 ? moment(label).format('MMM DD') : ''
            }
          },
          stacked: true,
          gridLines: {
            display: false,
            drawBorder: false
          }
        }]
      },
      lineAtIndex: this.props.dateIndex,
      selectedDate: this.props.selectedDate,
      onClick: (e, elements) => {
        if (elements && elements.length > 0) {
          this.props.setDateIndex(elements[0]._index)
        }
      }
    }
    if (dataSet.length === 0) {
      return null
    }
    return (
      <Box>
        <Bar
          data={data}
          options={options} />
      </Box>
    )
  }
}

export default BarWrap